import { useQuery } from '@tanstack/react-query';

import { getPatientChat } from '../../../api/chats';
import { useAuth } from '../../auth/AuthProvider';

export function usePatientChat(patientId: string) {
  const { tokens } = useAuth();

  return useQuery({
    queryKey: ['patient-chat', patientId],
    queryFn: () => getPatientChat(patientId, tokens!.access_token),
    enabled: Boolean(patientId && tokens?.access_token),
  });
}
